import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

import { ref } from "vue";

import { getClasses } from "~/js/composables/classes";

interface Legend {
	label: string;
	color: string;
}

interface Props {
	legend: Array<Legend>;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListLegend',
  props: {
    legend: {},
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	color: {
		display: "block grow-0 shrink-0",
		rounded: "rounded-full",
		size: "w-6 h-6",
	},
	figcaption: {
		flex: "flex flex-wrap items-center justify-center",
		font: "font-primary text-base",
		color: "text-black",
		utilities: props.utilities,
		spacing: "pt-4",
	},
	item: {
		flex: "flex items-center space-x-2 px-4 py-2",
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figcaption", {
    class: _normalizeClass(_unref(getClasses)(classes.value, 'figcaption'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.legend, (item) => {
      return (_openBlock(), _createElementBlock("span", {
        key: item.label,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'item'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_unref(getClasses)(classes.value, 'color')),
          style: _normalizeStyle(`background: ${item.color}`)
        }, null, 6),
        _createElementVNode("span", null, _toDisplayString(item.label), 1)
      ], 2))
    }), 128))
  ], 2))
}
}

})